module.exports = __webpack_public_path__ + "img/full-img1.c2875b71.png";